var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c(
      "div",
      { staticClass: "horizontal-menu-wrapper" },
      [_vm._t("horizontal-menu")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "main-content-wrapper", attrs: { id: "main-content" } },
      [
        _vm._t("main-content", function () {
          return [_vm._v("\n      Main content should be here\n    ")]
        }),
        _vm._v(" "),
        _c("div", { staticClass: "bottom-white-space" }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }